import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  templateUrl: './required.component.html',
  styleUrls: ['./required.component.scss'],
})
export class RequiredMissedDialog {
  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly fields,
    public dialog: MatDialogRef<RequiredMissedDialog>) { }

  public close(isApproved: boolean){
    this.dialog.close(isApproved);
  }
}
